var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9268 5.4082L13.4443 0.960938C13.2539 0.386719 12.7178 0 12.1113 0H7.96875V5.625H14.9619C14.9502 5.55176 14.9502 5.47852 14.9268 5.4082ZM7.03125 0H2.88867C2.28223 0 1.74609 0.386719 1.55566 0.960938L0.0732422 5.4082C0.0498047 5.47852 0.0498047 5.55176 0.0380859 5.625H7.03125V0ZM0 6.5625V13.5938C0 14.3701 0.629883 15 1.40625 15H13.5938C14.3701 15 15 14.3701 15 13.5938V6.5625H0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/s3.69d00b1e9506cb1551147db847d40c80.svg";
export { ForwardRef as ReactComponent };